module.exports = __webpack_public_path__ + "static/media/lg50-2.21ae8aaf.png";